import type { DifferentProps } from '@/components/claims/Different';
import type { HeroProps } from '@/components/claims/Hero';
import type { HowItWorksProps } from '@/components/claims/HowItWorks';
import type { ReviewsProps } from '@/components/claims/Reviews';
import type { StatsProps } from '@/components/claims/Stats';
import { sharedConfig } from '@/pageConfig/shared';
import type { BasePageConfig } from '../../BasePageConfig';
import { config as enUsConfig } from '../us/en';

export interface Config extends BasePageConfig {
  hero: HeroProps;
  stats: StatsProps;
  howItWorks: HowItWorksProps;
  reviews: ReviewsProps;
  different: DifferentProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-NL'].layout },
  seo: {
    ...enUsConfig.seo,
    description:
      'Submit and manage Netherlands insurance claims easily on the Lemonade app. Our tech-driven process offers fast resolutions with dedicated team support.',
  },
  hero: { ...enUsConfig.hero },
  howItWorks: {
    ...enUsConfig.howItWorks,
    steps: {
      ...enUsConfig.howItWorks.steps,
      humans: {
        ...enUsConfig.howItWorks.steps.humans,
        content: 'For claims that require a closer look, our devoted human <b>claims team</b> handles ASAP',
      },
    },
  },
  stats: { ...enUsConfig.stats },
  reviews: { ...enUsConfig.reviews, showVideo: false },
  different: { ...enUsConfig.different, title: 'Paying Claims. Doing Good' },
};
